import { MailIcon, InstagramIcon, LinkedinIcon } from 'lucide-react';

export default function Footer() {
  return (
    <footer className="bg-darkerBlue w-full text-primaryBlack border-t border-primaryGrey mt-10">
      <div className="max-w-6xl mx-auto px-4 py-8 flex flex-col md:flex-row items-center justify-between gap-4">
        {/* Left side: Contact Info */}
        <div className="text-center md:text-left">
          <p className="font-semibold text-lg">Contact Us</p>
          <a
            href="mailto:info@greetli.ch"
            className="text-linkColor hover:text-darkOrange underline transition"
          >
            info@greetli.ch
          </a>
        </div>

        {/* Right side: Social Links */}
        <div className="flex gap-6 items-center">
          <a
            href="https://www.instagram.com/greetli.ch"
            target="_blank"
            rel="noopener noreferrer"
            className="text-linkColor hover:text-primaryOrange transition"
            aria-label="Instagram"
          >
            <InstagramIcon className="w-6 h-6" />
          </a>
          <a
            href="https://www.linkedin.com/company/greetli"
            target="_blank"
            rel="noopener noreferrer"
            className="text-linkColor hover:text-primaryOrange transition"
            aria-label="LinkedIn"
          >
            <LinkedinIcon className="w-6 h-6" />
          </a>
          <a
            href="mailto:info@greetli.ch"
            className="text-linkColor hover:text-primaryOrange transition"
            aria-label="Email"
          >
            <MailIcon className="w-6 h-6" />
          </a>
        </div>
      </div>
    </footer>
  );
}
